import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class StagingTripService {

  constructor(
    private http: HttpClient
  ) {

  }
  getAllTrips(queryParam: any) {
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get(urls.API_URL + urls.STAGING_TRIPS, { params })
      .pipe(catchError(errorHandl));
  }

  getTripById(id: any) {
    return this.http.get(urls.API_URL + urls.STAGING_TRIPS + `/${id}`)
      .pipe(catchError(errorHandl));
  }
  updateTrip(payload: any, id: any) {
    return this.http.patch(urls.API_URL + urls.STAGING_TRIPS + `/${id}`, payload)
      .pipe(catchError(errorHandl));

  }

}
